import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import Dialog from '@comp/Dialog/Dialog';
import { useRouter } from 'next/router';
import useGroupsInvitationStore from '@stores/groups/groupsInvitationStore';

const GroupsJoinDialog = ({
  title,
  description,
  type,
  open,
  acceptOnClick
}) => {
  const [isDialogVisible, setIsDialogVisible] = useState(open);
  const router = useRouter();
  const { toggleGroupInvitationReceived } = useGroupsInvitationStore();

  const closeDialog = () => {
    setIsDialogVisible(false);
  };

  const onClickAccept = () => {
    acceptOnClick();
    closeDialog();
  };

  const onClickReject = () => {
    closeDialog();
    toggleGroupInvitationReceived(false);
    const { goalSlug, goalUID } = router.query;
    router.replace(
      '/goal/[goalSlug]/[goalUID]',
      `/goal/${goalSlug}/${goalUID}`,
      { shallow: true }
    );
  };

  useEffect(() => {
    if (open !== undefined) setIsDialogVisible(open);
  }, [open]);

  return (
    <Dialog
      type="default"
      onClose={closeDialog}
      dialogState={isDialogVisible}
      heading={title}
      message={description}
      messageColor="var(--color-i-text-black)"
      rejectLabel={type === 'error' ? 'Got it' : 'Cancel'}
      rejectOnClick={onClickReject}
      acceptLabel={type !== 'error' ? 'Join Group' : null}
      acceptLabelVariant="filled"
      acceptLabelTheme="green"
      acceptOnClick={onClickAccept}
    />
  );
};

export default GroupsJoinDialog;

GroupsJoinDialog.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  acceptOnClick: PropTypes.func
};

GroupsJoinDialog.defaultProps = {
  acceptOnClick: () => {}
};
